!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e(require("react")) : "function" == typeof define && define.amd ? define(["react"], e) : "object" == typeof exports ? exports.ReactRectangle = e(require("react")) : t.ReactRectangle = e(t.React);
}(this, function (t) {
  return function (t) {
    function e(n) {
      if (r[n]) return r[n].exports;
      var o = r[n] = {
        exports: {},
        id: n,
        loaded: !1
      };
      return t[n].call(o.exports, o, o.exports, e), o.loaded = !0, o.exports;
    }
    var r = {};
    return e.m = t, e.c = r, e.p = "", e(0);
  }([function (t, e, r) {
    "use strict";

    function n(t) {
      return t && t.__esModule ? t : {
        "default": t
      };
    }
    var o = r(1),
      i = n(o);
    t.exports = i["default"];
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      return t && t.__esModule ? t : {
        "default": t
      };
    }
    function o(t, e) {
      var r = {};
      for (var n in t) e.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(t, n) && (r[n] = t[n]);
      return r;
    }
    var i = Object.assign || function (t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = arguments[e];
        for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
      }
      return t;
    };
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.calculateAspectRatio = void 0;
    var u = r(7),
      a = n(u),
      c = r(3),
      f = n(c),
      l = r(2),
      p = n(l),
      s = r(5),
      d = n(s),
      y = r(4),
      v = n(y);
    e["default"] = function (t) {
      var e = t.aspectRatio,
        r = void 0 === e ? 1 : e,
        n = t.children,
        u = t.style,
        c = o(t, ["aspectRatio", "children", "style"]),
        f = b(r);
      return a["default"].createElement("div", i({
        style: i({
          position: "relative"
        }, u)
      }, c), a["default"].createElement("div", {
        style: {
          display: "block",
          paddingTop: 100 * f + "%"
        }
      }), a["default"].createElement("div", {
        style: {
          position: "absolute",
          bottom: 0,
          left: 0,
          top: 0,
          right: 0
        }
      }, n));
    };
    var b = function b(t) {
      if ((0, f["default"])(t)) return 1 / t;
      if ((0, p["default"])(t) && void 0 !== t[0] && void 0 !== t[1]) return t[1] / t[0];
      if (void 0 !== t.width && void 0 !== t.height) return t.height / t.width;
      if ((0, d["default"])(t)) {
        var e = Number.parseFloat(t);
        if ((0, v["default"])(e)) throw new Error("Cannot parse input string: " + t);
        return 1 / Number.parseFloat(t);
      }
      throw new Error("Cannot parse props.aspectRatio: " + t);
    };
    e.calculateAspectRatio = b;
  }, function (t, e) {
    var r = Array.isArray;
    t.exports = r;
  }, function (t, e, r) {
    (function (t, r) {
      function n(t) {
        return t && t.Object === Object ? t : null;
      }
      function o(t) {
        return "number" == typeof t && d(t);
      }
      var i = {
          "function": !0,
          object: !0
        },
        u = i[typeof e] && e && !e.nodeType ? e : null,
        a = i[typeof t] && t && !t.nodeType ? t : null,
        c = n(u && a && "object" == typeof r && r),
        f = n(i[typeof self] && self),
        l = n(i[typeof window] && window),
        p = n(i[typeof this] && this),
        s = c || l !== (p && p.window) && l || f || p || Function("return this")(),
        d = s.isFinite;
      t.exports = o;
    }).call(e, r(6)(t), function () {
      return this;
    }());
  }, function (t, e) {
    function r(t) {
      return !!t && "object" == typeof t;
    }
    function n(t) {
      return o(t) && t != +t;
    }
    function o(t) {
      return "number" == typeof t || r(t) && a.call(t) == i;
    }
    var i = "[object Number]",
      u = Object.prototype,
      a = u.toString;
    t.exports = n;
  }, function (t, e) {
    function r(t) {
      return !!t && "object" == typeof t;
    }
    function n(t) {
      return "string" == typeof t || !a(t) && r(t) && u.call(t) == o;
    }
    var o = "[object String]",
      i = Object.prototype,
      u = i.toString,
      a = Array.isArray;
    t.exports = n;
  }, function (t, e) {
    t.exports = function (t) {
      return t.webpackPolyfill || (t.deprecate = function () {}, t.paths = [], t.children = [], t.webpackPolyfill = 1), t;
    };
  }, function (e, r) {
    e.exports = t;
  }]);
});